import { MonoBehavior } from 'game/core/monoBehavior';
import { getAsset } from 'game/preloadGameAssets';
import { Container, Sprite } from 'pixi.js';

const LOADER_TIME = 1000;
const STEPS = 12;
const ROTATION_ANGLE = (Math.PI * 2) / STEPS;
export class AssetLoader extends MonoBehavior {
    frame: number;
    container: Container;
    sprite?: Sprite;
    color = 0xffffff;
    constructor(parent: Container) {
        super();
        this.frame = 0;
        this.container = new Container();
        parent.addChild(this.container);
        this.drawLoader();
    }
    async drawLoader() {
        const img = await getAsset('loader/loader', 'svg');
        this.sprite = Sprite.from(img);
        this.sprite.width = 42;
        this.sprite.height = 42;
        this.sprite.anchor.set(0.5);
        this.container.addChild(this.sprite);

        this.setColor(this.color);
    }
    setColor(color: number) {
        this.color = color;
        if (this.sprite) this.sprite.tint = color;
    }

    setPosition(x: number, y: number) {
        this.container.position.set(x, y);
    }
    update(): void {
        const rotationFrame = Math.floor(((performance.now() % LOADER_TIME) / LOADER_TIME) * STEPS);
        this.container.rotation = rotationFrame * ROTATION_ANGLE;
    }

    destroy() {
        super.destroy();
        this.container.removeFromParent();
        this.container.removeChildren();
    }
}
